import { css } from '@linaria/core';
import { ORG_ROLE_DESCRIPTIONS, RolesT } from 'modules/Organizations/constants';
export const OrgRole: React.FC<{
  roleId?: string;
  roleName?: string;
}> = ({
  roleId,
  roleName
}) => {
  if (!roleId || !roleName) {
    return null;
  }
  const description = ORG_ROLE_DESCRIPTIONS[(roleId as RolesT)];
  return <div className={orgRoleStyles.wrapper}>
      <span className={orgRoleStyles.name}>{roleName}</span>
      <p className={orgRoleStyles.description}>{description}</p>
    </div>;
};
const orgRoleStyles = {
  wrapper: "odules__Organizations__components__MembersTable__OrgRole_tsx-wrapper-wxdpduw",
  name: "odules__Organizations__components__MembersTable__OrgRole_tsx-name-nldplsx",
  description: "odules__Organizations__components__MembersTable__OrgRole_tsx-description-d1rrxusy"
};

require("./OrgRole.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./OrgRole.tsx");